import { GridColumnProps } from "@progress/kendo-react-grid";
import { CellWrapper } from "../__common/CellWrapper";

import {
  PortfolioPercentageCell,
  CurrentPriceCell,
  QuantityCell,
  NameCell,
  DeleteCell,
  TotalValueCell,
  OriginalPercentageCell,
  OriginalValueCell,
} from "./cells";
import OriginalQuantityCell from "./cells/OriginalQuantityCell";

export const whatIfPositionsColumns: (
  baseCurrencySymbol: string
) => GridColumnProps[] = (baseCurrencySymbol: string) => [
  {
    field: "name",
    title: "TICKER/NAME",
    removeBorderLeft: true,
    cell: (props) => <CellWrapper gridCellProps={props} cell={NameCell} />,
  },
  {
    field: "price",
    filterable: true,
    rightAligned: true,
    removeBorderLeft: true,
    title: `PRICE 1 YR AGO`,
    cell: (props) => (
      <CellWrapper gridCellProps={props} cell={CurrentPriceCell} rightAligned />
    ),
  },
  {
    field: "oldQuantity",
    title: "ORIGINAL QUANTITY",
    rightAligned: true,
    removeBorderLeft: true,
    cell: (props) => (
      <CellWrapper
        gridCellProps={props}
        cell={OriginalQuantityCell}
        rightAligned
      />
    ),
  },
  {
    field: "oldValue",
    title: "ORIGINAL VALUE",
    rightAligned: true,
    removeBorderLeft: true,
    cell: (props) => (
      <CellWrapper
        gridCellProps={props}
        cell={OriginalValueCell}
        rightAligned
      />
    ),
  },
  {
    field: "oldPercentage",
    title: "ORIGINAL PORTFOLIO %",
    rightAligned: true,
    removeBorderLeft: true,
    cell: (props) => (
      <CellWrapper
        gridCellProps={props}
        cell={OriginalPercentageCell}
        rightAligned
      />
    ),
  },
  {
    field: "quantity",
    title: "NEW QUANTITY",
    removeBorderLeft: true,
    cell: (props) => <CellWrapper gridCellProps={props} cell={QuantityCell} />,
  },

  {
    field: "totalValue",
    rightAligned: true,
    removeBorderLeft: true,
    title: `NEW VALUE (${baseCurrencySymbol})`,
    cell: (props) => (
      <CellWrapper gridCellProps={props} cell={TotalValueCell} rightAligned />
    ),
  },

  {
    field: "portfolioPercentage",
    title: "NEW PORTFOLIO %",
    removeBorderLeft: true,
    cell: (props) => (
      <CellWrapper gridCellProps={props} cell={PortfolioPercentageCell} />
    ),
  },

  {
    field: "",
    width: 50,
    rightAligned: true,
    removeBorderLeft: true,
    title: ``,
    cell: (props) => <CellWrapper gridCellProps={props} cell={DeleteCell} />,
  },
];
